module.exports = __webpack_public_path__ + "6725c3fb1f3abd7ebdcb2d244758f706.woff2";